module.exports = __webpack_public_path__ + "img/lba.cd2074eb.jpeg";